document.addEventListener(
  'submit',
  async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.dataset.type !== 'add-to-cart-form') return;

    const productForm = form.closest('product-form');
    if (!productForm) return;

    const addonInputs = Array.from(
      productForm.querySelectorAll('.product-addon-checkbox:checked')
    );

    if (!addonInputs.length) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const submitButton = productForm.querySelector('[name="add"]');
    const spinner = productForm.querySelector('.loading__spinner');
    const errorWrapper = productForm.querySelector('.product-form__error-message-wrapper');
    const errorMessage = productForm.querySelector('.product-form__error-message');
    const cart =
      document.querySelector('cart-notification') ||
      document.querySelector('cart-drawer');

    if (submitButton?.getAttribute('aria-disabled') === 'true') return;

    if (errorWrapper) errorWrapper.setAttribute('hidden', '');
    submitButton?.setAttribute('aria-disabled', 'true');
    submitButton?.classList.add('loading');
    spinner?.classList.remove('hidden');

    const formData = new FormData(form);
    const mainVariantId = Number(formData.get('id'));
    const mainQuantity = Number(formData.get('quantity') || 1);

    const items = [
      {
        id: mainVariantId,
        quantity: mainQuantity
      }
    ];

    addonInputs.forEach((input) => {
      const variantId = Number(input.value);
      const quantity = Number(input.dataset.quantity || 1);

      if (variantId) {
        items.push({
          id: variantId,
          quantity
        });
      }
    });

    const payload = { items };

    if (cart && typeof cart.getSectionsToRender === 'function') {
      payload.sections = cart.getSectionsToRender().map((section) => section.id);
      payload.sections_url = window.location.pathname;

      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(document.activeElement);
      }
    }

    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/json'
        },
        body: JSON.stringify(payload)
      });

      const data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'カートへの追加に失敗しました。');
      }

      if (cart && typeof cart.renderContents === 'function' && data.sections) {
        cart.renderContents(data);
      } else {
        window.location.href = '/cart';
      }
    } catch (error) {
      console.error(error);

      if (errorWrapper && errorMessage) {
        errorMessage.textContent = error.message;
        errorWrapper.removeAttribute('hidden');
      }
    } finally {
      submitButton?.classList.remove('loading');
      submitButton?.removeAttribute('aria-disabled');
      spinner?.classList.add('hidden');

      if (cart && cart.classList.contains('is-empty')) {
        cart.classList.remove('is-empty');
      }
    }
  },
  true
);